import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AdminMenuList from "./list";

const GoodsIn = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const Location = useLocation();

  return (
    <>
      <Routes>
        <Route path={`/`} element={<Navigate replace="/" to={`${Location.pathname}/list`} />} />
        <Route path={"list"} element={<AdminMenuList />} />
      </Routes>
    </>
  );
};

export default GoodsIn;
